import { render, staticRenderFns } from "./MobileModule.vue?vue&type=template&id=649589de&scoped=true&"
import script from "./MobileModule.vue?vue&type=script&lang=js&"
export * from "./MobileModule.vue?vue&type=script&lang=js&"
import style0 from "./MobileModule.vue?vue&type=style&index=0&id=649589de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649589de",
  null
  
)

component.options.__file = "MobileModule.vue"
export default component.exports